import axios from '@axios'

const route = 'configuration/self_service_screen'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll() {
      return axios.get(route)
    },

    updateOrCreate(context, data) {
      return axios.post(route, data)
    },
  },
}
